module.exports = __webpack_public_path__ + "img/onetarget.bfdc1e1f.png";